import { useState } from 'react';
import { faqData } from '@/mocks/siteData';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="w-full px-4 md:px-6 py-14 bg-background-100">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">
            关于<strong>中文字幕日韩资源</strong>的常见疑问解答
          </p>
        </div>

        <div className="space-y-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="bg-background-50 rounded-xl border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-sm text-foreground-800 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center flex-shrink-0 rounded-full transition-colors ${
                  openIndex === index ? 'bg-primary-500 text-white' : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`text-sm ${openIndex === index ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </div>
              </button>
              <div
                className={`transition-all duration-300 overflow-hidden ${
                  openIndex === index ? 'max-h-96 pb-4 px-5' : 'max-h-0'
                }`}
              >
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>

      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqData.map((faq) => ({
              '@type': 'Question',
              name: faq.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: faq.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}